<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner" 
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Manifestation Details</b-navbar-brand>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="
            ffExportDetail.allModuleId ? ffExportDetail.allModuleId : ''
          "
          :jobSeriesBanner="
            ffExportDetail.ffExportFclSeries ? ffExportDetail.ffExportFclSeries : ''
          "
          :bannerClientName="ffExportDetail.clientName ? ffExportDetail.clientName : ''"
          iconId="fa fa-ship"
        />
        <!-- :bannerClientName="ImportDetail.clientName ? ImportDetail.clientName : ''" -->
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- <div
                class="mt-4"
                v-if="
                  (AddManifestationDetail.manifestationId != '' && accounts == false) ||
                  (AddManifestationDetail.manifestationId != '' && role == 'Admin')
                "
              > <input
                  :id="'revcheckbox'"
                  name="checkbox-1"
                  type="checkbox"
                  v-model="AddManifestationDetail.revisedMail"
                  @click="RevisedAss('revcheckbox')"
                  value="1"
                  unchecked-value="0"
                />
                <span class="error">Send Revised Expenses Request</span>
              </div> -->
              <!-- {{ lineChennaihardManifestationModalArray }} -->
              <b-row>
                <b-col lg="4">
                  <b-button
                    v-if="branch_code == 'MAA'"
                    id="show-btn"
                    size="sm"
                    variant="primary"
                    @click="addChennaihardArry"
                  >
                    Add Pre-Feed<i class="fa fa-plus" aria-hidden="true"></i
                  ></b-button>
                </b-col>
                <b-col lg="12">
                  <span class="error pull-right" v-if="ManifestationCreated"><b>{{
                    " "+ManifestationCreated
                  }}</b><br/></span>
                  </b-col><b-col lg="12">
                  <span class="error pull-right" v-if="ManifestationUpdated"><b>{{
                    ManifestationUpdated
                  }}</b><br/></span>  </b-col><b-col lg="12">
                  <!-- <span
                    v-if="
                      last_updated != '' &&
                      last_updated != null &&
                      last_updated != undefined
                    "
                    class="pull-right"
                    ><b class="error">{{ last_updated }}</b></span
                  > -->
                </b-col>
                  <b-col lg="12"> 
                  <ContainerTable
                    v-if="ffExportDetail.allModuleId"
                    :PMC_JOBID="ffExportDetail.allModuleId ? Number(ffExportDetail.allModuleId) : 0"
                    :containers="[]"
                    :showContainerStatus="''"
                    @status-change="activateUser"
                  />
                </b-col>
                <b-col cols="4" class="mt-2">
                  <label for="blType">Type <span class="error">*</span></label>

                  <model-list-select
                    :list="agentTypeList"
                    option-value="TypeVal"
                    option-text="TypeTxt"
                    v-model="AddManifestationDetail.type_of_agent"
                    placeholder="Select Type"
                    @input="getAgentConsigneeList(AddManifestationDetail.type_of_agent)"
                  ></model-list-select>
                  <span class="error" v-if="!AddManifestationDetail.type_of_agent">{{
                    errorManifest.type_of_agent
                  }}</span>
                </b-col>
                <b-col cols="4" class="mt-2">
                  <label for="blType">
                    {{ AddManifestationDetail.type_of_agent }}
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    :list="
                      getAllAgentColoaderList.length > 0
                        ? getAllAgentColoaderList
                        : AddManifestationDetail.type_of_agent == 'Agent'
                        ? $store.getters['common/getAllAgentColoaderList']
                        : $store.getters['common/getAllConsigneeList']
                    "
                    option-value="agentName"
                    option-text="agentName"
                    v-model="AddManifestationDetail.AgentColoader"
                    :placeholder="
                      AddManifestationDetail.type_of_agent == 'Consignee'
                        ? 'Select Consignee'
                        : 'Select Agent/Coloader'
                    "
                    @input="getConsigneeAgentDetails"
                  ></model-list-select>
                  <span class="error" v-if="errorManifest.AgentColoader">{{
                    errorManifest.AgentColoader +
                    " " +
                    AddManifestationDetail.type_of_agent
                  }}</span>
                </b-col>
              </b-row>

              <b-card class="mt-2">
                <table class="table table-sm table-bordered">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col">SN.</th>
                      <th scope="col">Type</th>
                      <th scope="col">Particulars</th>
                      <th scope="col" style="width: 5%">Container Count</th>
                      <th scope="col">Amount (Accept Only Numbers)</th>
                      <th scope="col">Currency</th>
                      <th scope="col" style="width: 7%">Final AMT</th>
                      <th scope="col">Remarks</th>
                      <!-- <th scope="col">Payment Status</th> -->
                      <th scope="col">
                        Action
                        <b-button
                          id="show-btn"
                          size="sm"
                          variant="primary"
                          @click="addInvArry"
                        >
                          Add <i class="fa fa-plus" aria-hidden="true"></i
                        ></b-button>
                      </th>
                    </tr>
                    <tr v-for="(itm, idx) in lineADDManifestationModalArray" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td>
                        <model-list-select
                          :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="TypeList"
                          v-model="itm.addManifestation_type"
                          option-value="typeVal"
                          option-text="typeText"
                          placeholder="Select Type"
                        ></model-list-select>
                        <span class="error" v-if="itm.addManifestation_type_err">{{
                          itm.addManifestation_type_err
                        }}</span>
                      </td>
                      <td>
                        <model-list-select
                          :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="ParticularList"
                          v-model="itm.addManifestation_ledgerId"
                          option-value="partVal"
                          option-text="partText"
                          placeholder="Select Particular"
                        ></model-list-select>
                        <!-- <model-list-select
                          :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="ledgerData"
                          v-model="itm.addManifestation_ledgerId"
                          option-value="ledgerId"
                          option-text="ledger"
                          placeholder="Select "
                        ></model-list-select> -->
                        <span class="error" v-if="itm.addManifestation_ledgerId_err">{{
                          itm.addManifestation_ledgerId_err
                        }}</span>
                      </td>
                      <!-- <td>{{ (itm.manifestationId || itm.manifestationId>0)?itm.container_count:getSelectedContList.length }}</td> -->
                       <td ><b-form-input
                          :formatter="capitalizeAll"
                          id="container_count"
                          name="container_count"
                          v-model="itm.container_count"
                          @input="updateAmount(itm)"
                          @change="updateAmount(itm)"
                          v-on:keyup="TotalAMT"
                          type="number"
                        /></td>
                      <td>
                        <b-form-input
                          :disabled="itm.manifestationId != '' ? true : false"
                          :formatter="capitalizeAll"
                          id="amount"
                          name="amount"
                          v-model="itm.addManifestation_amount"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT"
                          type="number"
                        ></b-form-input>
                        <span class="error" v-if="itm.addManifestation_amount_err">{{
                          itm.addManifestation_amount_err
                        }}</span>
                      </td>
                      <td>
                        <model-list-select
                          :isDisabled="itm.manifestationId != '' ? true : false"
                          :list="CurrencyList"
                          v-model="itm.addManifestation_currency"
                          option-value="currency_id"
                          option-text="currencyCode"
                          placeholder="Select Currency"
                        ></model-list-select>
                        <span class="error" v-if="itm.addManifestation_currency_err">{{
                          itm.addManifestation_currency_err
                        }}</span>
                      </td>
                      <td>{{ itm.final_amt || getSelectedContList.length*itm.addManifestation_amount }}</td>
                      <td>
                        <b-form-textarea
                          :disabled="itm.manifestationId != '' ? true : false"
                          :formatter="capitalizeAll"
                          id="remark"
                          name="remark"
                          v-model="itm.addManifestation_remark"
                        ></b-form-textarea>
                        <span class="error" v-if="itm.addManifestation_remark_err">{{
                          itm.addManifestation_remark_err
                        }}</span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :list="statusList"
                          v-model="itm.addManifestation_payStatus"
                          option-value="payVal"
                          option-text="payText"
                          placeholder="Select "
                        ></model-list-select>
                        <span class="error" v-if="itm.addManifestation_payStatus_err">{{
                    itm.addManifestation_payStatus_err
                  }}</span>
                      </td> -->
                      <td>
                        <b-button
                          :disabled="itm.manifestationId != '' ? true : false"
                          class="ml-auto"
                          id="show-btn"
                          size="sm"
                          variant="danger"
                          @click="removeInvArry(idx)"
                        >
                          <!-- v-if="idx != 0" -->
                          Remove
                          <i class="fa fa-minus" aria-hidden="true"></i
                        ></b-button>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px"
                          >Debit Total</b
                        >
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotDebit
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px"
                          >Credit Total</b
                        >
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotCredit
                        }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <b style="color: blue; font-weight: bold; font-size: 18px"
                          >Net Total</b
                        >
                      </td>
                      <td colspan="4">
                        <b style="color: blue; font-weight: bold; font-size: 18px">{{
                          TotAMT
                        }}</b>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td colspan="3"><b style="color:blue;font-weight:bold;font-size:18px;">Total</b></td>
                      <td colspan="3"><b style="color:blue;font-weight:bold;font-size:18px;">{{TotAMT}}</b></td>
                    </tr> -->
                  </tbody>
                </table>
                <!-- {{ lineChennaihardManifestationModalArray.length }} -->
                <span
                  v-if="
                    lineChennaihardManifestationModalArray.length > 0 &&
                    lineChennaihardManifestationModalArray.length != 0
                  "
                  ><h4>Pre-Feed Details</h4>
                  <table class="table table-sm table-bordered">
                    <tbody style="background: white">
                      <tr>
                        <th scope="col" style="width: 10px">SN.</th>
                        <th scope="col" style="width: 60px">Type</th>
                        <th scope="col" style="width: 700px">Particulars</th>
                        <th scope="col">Amount (Accept Only Numbers)</th>
                        <th scope="col">Currency</th>
                        <th scope="col">Remarks</th>
                        <th scope="col">Action</th>
                      </tr>
                      <!-- <div
                      v-if="lineChennaihardManifestationModalArray.length > 0"
                    > -->
                      <!-- v-for="(item,index) in lineChennaihardManifestationModalArray"
                      :key="index" -->
                      <tr
                        v-for="(item, index) in lineChennaihardManifestationModalArray"
                        :key="index"
                      >
                        <th scope="row">{{ index + 1 }}</th>
                        <td>
                          <model-list-select
                            :isDisabled="item.manifestationId != '' ? true : false"
                            :list="TypeList"
                            v-model="item.addManifestation_type"
                            option-value="typeVal"
                            option-text="typeText"
                            placeholder="Select Type"
                          ></model-list-select>
                          <span class="error" v-if="item.addManifestation_type_err">{{
                            item.addManifestation_type_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-input
                            :disabled="item.manifestationId != '' ? true : false"
                            v-model="item.addManifestation_ledgerId"
                            placeholder="Enter Particular"
                          ></b-form-input>
                          <span class="error" v-if="item.addManifestation_ledgerId_err">{{
                            item.addManifestation_ledgerId_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-input
                            :disabled="item.manifestationId != '' ? true : false"
                            :formatter="capitalizeAll"
                            id="amount"
                            name="amount"
                            v-model="item.addManifestation_amount"
                            @input="CheckValueNumbers($event)"
                            @change="CheckValueNumbers($event)"
                            v-on:keyup="TotalChennaiAMTFunc"
                            type="number"
                          ></b-form-input>
                          <span class="error" v-if="item.addManifestation_amount_err">{{
                            item.addManifestation_amount_err
                          }}</span>
                        </td>
                        <td>
                          <model-list-select
                            :isDisabled="item.manifestationId != '' ? true : false"
                            :list="CurrencyList"
                            v-model="item.addManifestation_currency"
                            option-value="currency_id"
                            option-text="currencyCode"
                            placeholder="Select Currency"
                          ></model-list-select>
                          <span class="error" v-if="item.addManifestation_currency_err">{{
                            item.addManifestation_currency_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-textarea
                            :disabled="item.manifestationId != '' ? true : false"
                            :formatter="capitalizeAll"
                            id="remark"
                            name="remark"
                            v-model="item.addManifestation_remark"
                          ></b-form-textarea>
                          <span class="error" v-if="item.addManifestation_remark_err">{{
                            item.addManifestation_remark_err
                          }}</span>
                        </td>
                        <td>
                          <b-button
                            :disabled="item.manifestationId !== '' ? true : false"
                            class="ml-auto"
                            id="show-btn"
                            size="sm"
                            variant="danger"
                            @click="removeChennaihardArry(index)"
                          >
                            Remove
                            <i class="fa fa-minus" aria-hidden="true"></i
                          ></b-button>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <b style="color: blue; font-weight: bold; font-size: 18px"
                            >Debit Total</b
                          >
                        </td>
                        <td colspan="4">
                          <b style="color: blue; font-weight: bold; font-size: 18px">{{
                            TotChennaiDebit
                          }}</b>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <b style="color: blue; font-weight: bold; font-size: 18px"
                            >Credit Total</b
                          >
                        </td>
                        <td colspan="4">
                          <b style="color: blue; font-weight: bold; font-size: 18px">{{
                            TotChennaiCredit
                          }}</b>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <b style="color: blue; font-weight: bold; font-size: 18px"
                            >Net. Total</b
                          >
                        </td>
                        <td colspan="4">
                          <b style="color: blue; font-weight: bold; font-size: 18px">{{
                            TotalChennaiAMT
                          }}</b>
                        </td>
                      </tr>
                      <!-- </div> -->
                    </tbody>
                  </table>
                </span>
              </b-card>
              <b-row>
                <b-col lg="5"></b-col>
                <b-col lg="2"
                  ><b-button
                    v-if="
                      lineADDManifestationModalArray.length > 0 ||
                      lineChennaihardManifestationModalArray.length > 0
                    "
                    class="mt-3"
                    size="sm"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addAddManifestationDetail"
                    >Save & Submit
                  </b-button>

                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </b-col>
                <b-col lg="5"></b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="popMailAfter"
        ></md-dialog-confirm>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";

import ContainerTable from "../common/ContainerTable.vue";

export default {
  // props: ["allModuleId", "JOBSERIES"],
  beforeMount() {
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    this.$store.dispatch("common/setAllAgentColoaderList");
    // alert(this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"));
    if (
      this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId") != undefined &&
      this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId") != "" &&
      this.$sessionsStorage.get("JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/seaImport/sendManifestation");
      if (
        this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId") &&
        this.$sessionsStorage.get("sendManifest_ffIMPFclId")
      ) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },

  data() {
    return {
      getAllAgentColoaderList: [],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      TotAMT: "0",
      TotDebit: "0",
      TotCredit: "0",
      TotalChennaiAMT: "0",
      TotChennaiDebit: "0",
      TotChennaiCredit: "0",
      isValid: true,
      regex: /[0-9]/,
      branch_code: "",
      mainSalesSeries: "",
      assign_no_series: this.$sessionsStorage.get("JOBSERIES"),
      allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
      selectDateFormat,
      accounts: false,
      ffExportDetail: {
        POD: "",
        allModuleId: "",
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
        username: "",
      },
      // accounts: globalPermissionStatus("Accounts"),
      componentKey: 0,
      revisedADDManifestationDetails: [],
      items: [],
      lastSelectItem: {},
      ledgerData: ["gfdg"],
      CurrencyList: [],
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        {
          payVal: "1",
          payText: "PENDING",
        },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      ParticularList: [
        {
          partVal: "PAY TO LINE",
          partText: "PAY TO LINE",
        },
        {
          partVal: "PROFIT SHARE",
          partText: "PROFIT SHARE",
        },
        {
          partVal: "PAY TO CONSIGNEE",
          partText: "PAY TO CONSIGNEE",
        },
        {
          partVal: "SEA PRIORITY",
          partText: "SEA PRIORITY",
        },
        {
          partVal: "FREIGHT COLLECT FROM CONSIGNEE",
          partText: "FREIGHT COLLECT FROM CONSIGNEE",
        },
        {
          partVal: "ON CARRIAGE TO AGENT",
          partText: "ON CARRIAGE TO AGENT",
        },
        {
          partVal: "BILL TO CUSTOMER",
          partText: "BILL TO CUSTOMER",
        },
      ],
      TypeList: [
        {
          typeVal: "CREDIT",
          typeText: "CREDIT",
        },
        {
          typeVal: "DEBIT",
          typeText: "DEBIT",
        },
      ],
      showAlgo: false,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      AddManifestationDetail: {
        revisedMail: "0",
        manifestationId: "",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
        ffFclConsoExportId: "",
        addManifestation_type: "",
        addManifestation_ledgerId: "",
        addManifestation_amount: "",
        addManifestation_currency: "1",
        addManifestation_remark: "",
        addManifestation_payStatus: "",
        userId: "",

        type_of_agent: "Agent",
        consignee_id: "",
        consignee_name: "",
        agent_coloder_txt: "",
        AgentColoader: "",

        paymentMode: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
      },

      errorManifest: {
        AgentColoader: "",
        type_of_agent: "",
      },
      arrayErrorManifest: [
        {
          AgentColoader: "Please Select",
          type_of_agent: "Please Select Type",
        },
      ],

      permissionStatus: true,
      AddManifestationDetailArray: [],
      showMoreSB: false,

      role: this.$sessionsStorage.get("designation"),
      nextPageType: "",
      lineADDManifestationModalArray: [],
      lineChennaihardManifestationModalArray: [],
      last_updated: "",
      ManifestationCreated: "",
      ManifestationUpdated: "",
      validateINV: true,
      validate: true,
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
     CustomLoader,
    BannerComponent,
    Multiselect,
    ContainerTable,
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        !this.AddManifestationDetail.manifestationId
        ? true
        : false;
    },
    AddManifestationDetailArrayList() {
      return this.AddManifestationDetailArray;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
     activateUser(item) {
      this.getSelectedContList=item;
       this.lineADDManifestationModalArray = this.lineADDManifestationModalArray.map((el) => {
        // mutate each element or selectively update
        el.container_count = this.getSelectedContList.length;
        return el; // always return the element
      });
      console.log("Container toggled:", item);
    },
    onSelectPaymentMode(event, item) {
      // console.log(event,item)
      // item.
      this.$forceUpdate();
    },
    onSelectPaymentStatus(event, item) {
      this.$forceUpdate();
    },
    onChoosePaymentDate(event, item) {
      this.$forceUpdate();
    },
    onChooseInvoiceDate(event, item) {
      this.$forceUpdate();
    },
    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    addInvArry() {
      console.log("Add Manifestation Details");

      let obj = {
        manifestationId: "",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
        ffFclConsoExportId: "",
        addManifestation_type: "",
        addManifestation_ledgerId: "",
        addManifestation_currency: "1",
        addManifestation_amount: "",
        addManifestation_remark: "",
        addManifestation_payStatus: "",
        container_count: "",
        final_amt: "",

        addManifestation_type_err: "",
        addManifestation_ledgerId_err: "",
        addManifestation_currency_err: "",
        addManifestation_amount_err: "",
        addManifestation_remark_err: "",
        addManifestation_payStatus_err: "",
      };
      this.lineADDManifestationModalArray.push(obj);

      console.log(this.lineADDManifestationModalArray.length);
    },
    addChennaihardArry() {
      console.log("Add Chennai Manifestation Details");

      let obj = {
        type: "2", // Chennai Hardcore
        manifestationId: "",
        allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
        ffFclConsoExportId: "",
        addManifestation_type: "DEBIT",
        addManifestation_ledgerId: "",
        addManifestation_amount: "",
        addManifestation_currency: "1",
        addManifestation_remark: "",
        addManifestation_payStatus: "",

        addManifestation_type_err: "",
        addManifestation_ledgerId_err: "",
        addManifestation_currency_err: "",
        addManifestation_amount_err: "",
        addManifestation_remark_err: "",
        addManifestation_payStatus_err: "",
      };
      this.lineChennaihardManifestationModalArray.push(obj);

      console.log(this.lineChennaihardManifestationModalArray.length);
    },
    removeChennaihardArry(index) {
      console.log(
        "Remove lineChennaihardManifestationModalArray=>",
        this.lineChennaihardManifestationModalArray
      );
      this.lineChennaihardManifestationModalArray.splice(index, 1);
      this.TotalChennaiAMTFunc();
    },
    addChennaihardArry_bak() {
      console.log("Add Chennai Manifestation Details");

      let obj = [
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - PREPARATION TRANSHIPMENT BOE OR WAREHOUSE BILL OF ENTRY @ USD 85 PER CONTAINER",
          addManifestation_amount: "170.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_currency_err: "",
          addManifestation_amount_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - IOR CHARGES @ USD 55 PER SHIPMENT ON ACCOUNT IMPORT",
          addManifestation_amount: "55.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - EOR CHARGES @ USD 15 PER SHIPPING BILL FOR EXPORT (8 UNITS = 8 SHIPPING BILLS)",
          addManifestation_amount: "120.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - TRANSPORTATION FROM PORT TO FTWZ AND EMPTY RETURN TO LINER @ USD 285/40' X 2 CTR",
          addManifestation_amount: "570.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - UNLOADING CHARGES AT FTWZ @ USD 45/40' X 2 CTR",
          addManifestation_amount: "90.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - FLOOR SPACE AREA / STORAGE @ USD 1.5 PER SQ. FT PER MONTH (40'FT = 400 SQ FT) X 2 CTR",
          addManifestation_amount: "300.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - OUTBOUND CLEARANCE (FTWZ TO BONDED WAREHOUSE TRANSFER) @ USD 35 PER SHIPPING BILL",
          addManifestation_amount: "280.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - TRANSPORTATION FROM FTWZ TO AAPL MUMBAI AIRPORT @ USD 1700/40' X 2 CTR",
          addManifestation_amount: "3,400.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - CUSTOM CLEARANCE CHARGES AT AAPL MUMBAI AIRPORT @ USD 75/ULD (USD 75 X 8 ULD BOXES)",
          addManifestation_amount: "600.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId: "O/FREIGHT - DUNNAGE BAGS",
          addManifestation_amount: "0.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId: "O/FREIGHT - SURVEY CHARGES",
          addManifestation_amount: "0.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - LOADING CHARGES @ USD 10 PER ULD BOXES (USD 10 X 8 ULD BOXES)",
          addManifestation_amount: "80.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - LASHING CHARGES USD 30 PER CONTAINER (2 X 40' HC CONTAINER X USD 30)",
          addManifestation_amount: "60.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - S-LINE DESTINATION CHARGES @ USD 450/40' X 2 CTR",
          addManifestation_amount: "900.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId: "O/FREIGHT - IMPORT HANDLING FEE @ USD 20/SHIPMENT",
          addManifestation_amount: "20.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
        {
          type: "2", // Chennai Hardcore
          manifestationId: "",
          allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
          ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
          ffFclConsoExportId: "",
          addManifestation_type: "DEBIT",
          addManifestation_ledgerId:
            "O/FREIGHT - EIS @ USD 400/CONTAINER CONFIRMED BY EMAIL BY SCAN GLOBAL (ADDITIONAL CHARGES COLLECT)",
          addManifestation_amount: "800.00",
          addManifestation_currency: "1",
          addManifestation_remark: "",
          addManifestation_payStatus: "",

          addManifestation_type_err: "",
          addManifestation_ledgerId_err: "",
          addManifestation_amount_err: "",
          addManifestation_currency_err: "",
          addManifestation_remark_err: "",
          addManifestation_payStatus_err: "",
        },
      ];

      this.lineChennaihardManifestationModalArray = [];
      // for (let i = 0; i < obj.length; i++) {
      //   const element = obj[i];
      //   this.lineChennaihardManifestationModalArray.push(element);
      // }

      this.lineChennaihardManifestationModalArray = obj;
      if (this.lineChennaihardManifestationModalArray.length > 0) {
        this.TotalChennaiAMTFunc();
      }
      console.log(this.lineChennaihardManifestationModalArray.length);
      console.log(this.lineChennaihardManifestationModalArray);

      // this.$forceUpdate();
    },
    removeChennaihardArry_bak(index) {
      this.lineChennaihardManifestationModalArray.splice(index, 1);
      console.log(
        "Remove lineChennaihardManifestationModalArray=>",
        this.lineChennaihardManifestationModalArray
      );
      this.TotalChennaiAMTFunc();
      console.log(
        "Remove lineChennaihardManifestationModalArray length=>",
        this.lineChennaihardManifestationModalArray.length
      );
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        (this.items = []), (this.lastSelectItem = {});
        for (let i = 0; i < lineADDManifestationModalArray.length; i++) {
          this.lineADDManifestationModalArray[i].addManifestation_type = "";
          this.lineADDManifestationModalArray[i].addManifestation_ledgerId = "";
          this.lineADDManifestationModalArray[i].addManifestation_currency = "";
          this.lineADDManifestationModalArray[i].addManifestation_amount = "";
          this.lineADDManifestationModalArray[i].addManifestation_remark = "";
          this.lineADDManifestationModalArray[i].addManifestation_payStatus = "";
          this.lineADDManifestationModalArray[i].container_count = 1;
          this.lineADDManifestationModalArray[i].final_amt = "";
        }
      }
    },

    addRevisedADDManifestation(index, id) {
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.revisedADDManifestationDetails.push(
          this.lineADDManifestationModalArray[index]
        );
        this.lineADDManifestationModalArray[index].addManifestation_type = "";
        this.lineADDManifestationModalArray[index].addManifestation_ledgerId = "";
        this.lineADDManifestationModalArray[index].addManifestation_amount = "";
        this.lineADDManifestationModalArray[index].addManifestation_currency = "";
        this.lineADDManifestationModalArray[index].addManifestation_remark = "";
        this.lineADDManifestationModalArray[index].addManifestation_payStatus = "";
        this.lineADDManifestationModalArray[index].container_count = 1;
        this.lineADDManifestationModalArray[index].final_amt = "";
      } else {
        this.revisedADDManifestationDetails.splice(index, 1);
      }

      console.log("Revised mail => ", this.revisedADDManifestationDetails);
    },

    removeInvArry(index) {
      this.lineADDManifestationModalArray.splice(index, 1);
      this.TotalAMT();
    },

    getDueDate() {
      var date = new Date(this.AddManifestationDetail.sobDate);
      console.log(date);
      if (this.ImportDetail.shippingId == "15") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "8") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "13") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 9);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else if (this.ImportDetail.shippingId == "27") {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 13);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      } else {
        this.AddManifestationDetail.dueDate = date.setDate(date.getDate() + 6);
        this.AddManifestationDetail.dueDate = new Date(
          this.AddManifestationDetail.dueDate
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    validateAddManifestationDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.lineADDManifestationModalArray;
      for (let j = 0; j < MainARR.length; j++) {
        if (this.accounts != false) {
          if (MainARR[j].addManifestation_ledgerId != "") {
            if (MainARR[j].addManifestation_payStatus == "") {
              this.lineADDManifestationModalArray[j]["addManifestation_payStatus_err"] =
                "Payment Status Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineADDManifestationModalArray[j]["addManifestation_payStatus_err"] =
                "";
              validate_new = true;
            }
          }
        } else if (this.accounts == false || this.role == "Admin") {
          if (MainARR[j].addManifestation_type == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_type_err"] =
              "Note Type Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_type_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_ledgerId == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_ledgerId_err"] =
              "Particulars Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_ledgerId_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_amount == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_amount_err"] =
              "Amount Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_amount_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addManifestation_currency == "") {
            this.lineADDManifestationModalArray[j]["addManifestation_currency_err"] =
              "Currency Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDManifestationModalArray[j]["addManifestation_currency_err"] = "";
            validate_new = true;
          }
        }
      }
      console.log(
        "this.lineADDManifestationModalArray=>",
        this.lineADDManifestationModalArray
      );

      if (errCount > 0) {
        this.validateINV = false;
      }
      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },

    getAgentConsigneeList(type_of_agent) {
      this.AddManifestationDetail.AgentColoader = "";
      if (type_of_agent == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (type_of_agent == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.AddManifestationDetail.AgentColoader = "";
      console.log("AgentColoader Details=>", this.AddManifestationDetail.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.AddManifestationDetail.consignee_id = "";
      this.AddManifestationDetail.consignee_name = "";
      this.AddManifestationDetail.agent_coloder_id = "";
      this.AddManifestationDetail.agent_coloder_txt = "";
      if (this.AddManifestationDetail.type_of_agent == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.AddManifestationDetail.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.AddManifestationDetail.consignee_id = val.agntColoaderId;
            this.AddManifestationDetail.consignee_name = val.agentName;
          }
        });
      } else if (this.AddManifestationDetail.type_of_agent == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.AddManifestationDetail.AgentColoader) {
            console.log("Agent Details=>", val);
            this.AddManifestationDetail.agent_coloder_id = val.agntColoaderId;
            this.AddManifestationDetail.agent_coloder_txt = val.agentName;
          }
        });
      }
    },
    validateManiFest() {
      let validate_new = true;
      Object.keys(this.errorManifest).map((x, index) => {
        if (
          this.AddManifestationDetail[x] == "" ||
          this.AddManifestationDetail[x] == undefined ||
          this.AddManifestationDetail[x] == null
        ) {
          this.errorManifest[x] = this.arrayErrorManifest[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addAddManifestationDetail() {
      this.validateManiFest();
      this.validateAddManifestationDetail();
      if (this.validateINV == false || this.validate == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }
      this.AddManifestationDetail.salesExeuctionNo = this.$sessionsStorage.get(
        "JOBSERIES"
      );
      this.AddManifestationDetail.allModuleId = this.$sessionsStorage.get(
        "sendManifest_ffIMPFclallModuleId"
      );

      this.AddManifestationDetail.ffExportFclId = this.$sessionsStorage.get(
        "sendManifest_ffIMPFclId"
      );

      this.AddManifestationDetail.ManifestationDetails = this.lineADDManifestationModalArray;
      if (this.AddManifestationDetail.ManifestationDetails.length > 0) {
        this.AddManifestationDetail.TotAMT = this.TotAMT;
      }

      this.AddManifestationDetail.container_count=this.getSelectedContList.length;
        if (this.getSelectedContList && this.getSelectedContList.length > 0) {
          this.AddManifestationDetail.container_selected = this.getSelectedContList
            .map(c => c.containerNo)
            .join(',');
        } else {
          this.AddManifestationDetail.container_selected = '';
        }
        this.AddManifestationDetail.TotAMT1 = this.AddManifestationDetail.container_count*this.TotAMT;

      if (this.revisedADDManifestationDetails.length > 0) {
        this.AddManifestationDetail.revisedADDManifestationDetails = this.revisedADDManifestationDetails;
      }
      this.AddManifestationDetail.ChennaihardManifestationDetails = this.lineChennaihardManifestationModalArray;
      if (this.AddManifestationDetail.ChennaihardManifestationDetails.length > 0) {
        this.AddManifestationDetail.TotAMT = this.TotalChennaiAMT;
      }
      console.log("After => ", this.AddManifestationDetail);
      // return false
      if (this.validateINV != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Expenses/addAllFFManifestation.php`,
          data: JSON.stringify(this.AddManifestationDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              window.history.go(-1);
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      }
    },
    ParticularFilter(list, query) {
      return this.ledgerData.filter((x) => {
        return x.ledger.toLowerCase().includes(query.toLowerCase());
      });
    },
    getData() {
      this.doLoading();
      // alert(this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"));
      // alert(this.$sessionsStorage.get("sendManifest_ffIMPFclId"));
      let new_data = {
        allModuleId: this.$sessionsStorage.get("sendManifest_ffIMPFclallModuleId"),
        ffExportFclId: this.$sessionsStorage.get("sendManifest_ffIMPFclId"),
        isConsolidation: 0,
        ffFclConsoExportId: 0,
        type: "FF Import",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/getFFMainfestationDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            // this.ledgerData = [];
            this.CurrencyList = [];
            console.log("MyDataArr=>", data);
            console.log("Priyanshu Singh=>", data.mainManifestationData);
            // alert(data.UsersBranchName);
            if (data.editFFEX.length > 0) {
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
              this.mainSalesSeries = data.editFFEX[0].mainSalesSeries;
              let mydata = [];
              this.branch_code = "";
              mydata = this.mainSalesSeries.split("/");

              // if(mydata[2] == "MAA"){
              if (
                data.UsersBranchName != "" &&
                data.UsersBranchName != undefined &&
                data.UsersBranchName != null
              ) {
                this.branch_code = data.UsersBranchName;
              } else {
                this.branch_code = mydata[2];
              }
              // }
            }
            if (data.mainManifestationData.length > 0) {
              Object.keys(this.lineADDManifestationModalArray).map((x) => {
                this.lineADDManifestationModalArray[x] =
                  data.mainManifestationData[0][x] || "";
              });
              this.getSelectedContList=data.mainManifestationData[data.mainManifestationData.length-1].container_selected.split(",");
              
              this.AddManifestationDetailArray = data.mainManifestationData;
              this.ManifestationCreated = data.ManifestationCreated;
              this.ManifestationUpdated = data.ManifestationUpdated;
              let i = 0;
              data.mainManifestationData.forEach((element) => {
                this.last_updated = element.last_updated || "";
                this.AddManifestationDetail.manifestationId =
                  element.manifestationId || "";
                element["manifestationId"] = element.manifestationId || "";
                element["type"] = element.maa_type || "";
                element["allModuleId"] = element.allModuleId || "";
                element["addManifestation_type"] = element.noteType || "";
                element["addManifestation_ledgerId"] = element.ledgerId || "";
                element["addManifestation_amount"] = element.amount || "";
                element["addManifestation_currency"] = element.currency || "";
                element["addManifestation_remark"] = element.remark || "";
                element["container_count"] = element.container_count || "";
                element["final_amt"] = element.container_count*element.amount;
                // element["addManifestation_payStatus"] = element.addManifestation_payStatus || "";

                // if (element.manifestationId == "")
                //   element["PaymentStatusFlag"] = true;
                // else element["PaymentStatusFlag"] = false;

                // onSelectVendor(i,element,element.vendor)
                if (element.maa_type == 1) {
                  this.lineADDManifestationModalArray.push(element);
                }
                if (element.maa_type == 2) {
                  this.lineChennaihardManifestationModalArray.push(element);
                }

                this.AddManifestationDetail = {
                  type_of_agent: element.type_of_agent || "",
                  consignee_id: element.consignee_id || "",
                  consignee_name: element.consignee_name || "",
                  agent_coloder_txt: element.agent_coloder_txt || "",
                  AgentColoader:
                    element.type_of_agent == "Agent"
                      ? element.agent_coloder_txt
                      : element.consignee_name || "",
                };
                i++;
              });
              console.log("Happy SIngh=>", this.lineChennaihardManifestationModalArray);
              if (this.lineADDManifestationModalArray.length > 0) {
                this.TotalAMT();
                console.log("Menifest Details=>", this.lineADDManifestationModalArray);
              }
              if (this.lineChennaihardManifestationModalArray.length > 0) {
                this.TotalChennaiAMTFunc();
                console.log(
                  "Menifest Details=>",
                  this.lineChennaihardManifestationModalArray
                );
              }
              this.AddManifestationDetail.revisedMail = 0;
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.CurrencyList.length > 0) {
              this.CurrencyList = data.CurrencyList;
            } else {
              this.CurrencyList = [];
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    CheckValueNumbers(item) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
     updateAmount(item){
      item.final_amt=item.container_count*item.addManifestation_amount;
    },
    TotalAMT() {
      let TotAmount = 0;
      let TotCredit_Val = 0;
      let TotDebit_Val = 0;
      this.lineADDManifestationModalArray.forEach((value, index) => {
        let SIGN = "";
        console.log("happy Singh=>", value);
        let amount = 0;
        let Credit_Val = 0;
        let Debit_Val = 0;
        if (isNaN(value.addManifestation_amount) || value.addManifestation_amount == "") {
          amount = 0;
          Credit_Val = 0;
          Debit_Val = 0;
          value.final_amt=0;
        } else {
          value.final_amt=value.addManifestation_amount*value.container_count;
          amount = value.final_amt;
          if (value.addManifestation_type == "CREDIT") {
            Credit_Val = amount;
            SIGN = "-";
          }
          if (value.addManifestation_type == "DEBIT") {
            Debit_Val = amount;
            SIGN = "+";
          }
        }
        if (this.TotAMT == 0) {
          TotAmount = eval(amount);
          TotCredit_Val = eval(Credit_Val);
          TotDebit_Val = eval(Debit_Val);
        } else {
          TotAmount = eval(Debit_Val) - eval(Credit_Val) + eval(TotAmount);
          TotDebit_Val = eval(TotDebit_Val) + eval(Debit_Val);
          TotCredit_Val = eval(TotCredit_Val) + eval(Credit_Val);
          // TotAmount = eval(TotAmount+SIGN+amount);
          // TotAmount = eval(TotAmount)+eval(amount);
        }
        this.TotAMT = TotAmount;
        this.TotDebit = TotDebit_Val;
        this.TotCredit = TotCredit_Val;
      });
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    TotalChennaiAMTFunc() {
      let TotAmount = 0;
      let TotCredit_Val = 0;
      let TotDebit_Val = 0;
      this.lineChennaihardManifestationModalArray.forEach((value, index) => {
        let amount = 0;
        let SIGN = "";
        let Credit_Val = 0;
        let Debit_Val = 0;
        console.log("happy Singh=>", value);
        if (isNaN(value.addManifestation_amount) || value.addManifestation_amount == "") {
          amount = 0;
          Credit_Val = 0;
          Debit_Val = 0;
        } else {
          amount = value.addManifestation_amount;
          if (value.addManifestation_type == "CREDIT") {
            Credit_Val = amount;
            SIGN = "-";
          }
          if (value.addManifestation_type == "DEBIT") {
            Debit_Val = amount;
            SIGN = "+";
          }
        }
        if (this.TotalChennaiAMT == 0) {
          TotAmount = eval(amount);
          TotCredit_Val = eval(Credit_Val);
          TotDebit_Val = eval(Debit_Val);
        } else {
          TotAmount = eval(Debit_Val) - eval(Credit_Val) + eval(TotAmount);
          TotDebit_Val = eval(TotDebit_Val) + eval(Debit_Val);
          TotCredit_Val = eval(TotCredit_Val) + eval(Credit_Val);
          // TotAmount = eval(TotAmount+SIGN+amount);
          // TotAmount = eval(TotAmount)+eval(amount);
        }
        this.TotalChennaiAMT = TotAmount;
        this.TotChennaiDebit = TotDebit_Val;
        this.TotChennaiCredit = TotCredit_Val;
      });
      console.log("this.TotalChennaiAMT item=>", this.TotalChennaiAMT);
      this.$forceUpdate();
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffManifestation.vue?6afa6b7d